import React from 'react'

function InfoLight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
    >
      <path
        d="M6.36063 10.924C6.94526 10.81 7.50386 10.5698 8.00453 10.217C8.50521 9.86416 8.93816 9.40574 9.27866 8.86788C9.61916 8.33002 9.86055 7.72324 9.98904 7.0822C10.1175 6.44115 10.1306 5.77839 10.0275 5.13176C9.92443 4.48512 9.7072 3.86728 9.38823 3.3135C9.06927 2.75972 8.65481 2.28086 8.16852 1.90424C7.68224 1.52762 7.13364 1.26064 6.55407 1.11852C5.97449 0.976404 5.37529 0.961942 4.79066 1.07596C4.20603 1.18998 3.64743 1.43025 3.14676 1.78304C2.64608 2.13584 2.21313 2.59426 1.87263 3.13212C1.53213 3.66998 1.29074 4.27676 1.16225 4.9178C1.03376 5.55885 1.02069 6.22161 1.12378 6.86824C1.22686 7.51488 1.44409 8.13272 1.76305 8.6865C2.08202 9.24028 2.49648 9.71915 2.98277 10.0958C3.46905 10.4724 4.01765 10.7394 4.59722 10.8815C5.1768 11.0236 5.776 11.0381 6.36063 10.924L6.36063 10.924Z"
        stroke="#FBBF31"
      />
      <path d="M5.57568 6L5.57568 9" stroke="#FBBF31" stroke-linecap="square" />
      <path
        d="M5.57568 3.5L5.57568 3"
        stroke="#FBBF31"
        stroke-linecap="square"
      />
    </svg>
  )
}

export default InfoLight
